import axios from '@/api/config';
const scheduleObject={
  pageList(data){
      return  axios.post(`${process.env.BASE_URL}/scheduleObject/pageList`, data);
  },
  addScheduleObject(data){
    return  axios.post(`${process.env.BASE_URL}/scheduleObject/addScheduleObject`, data);
  },
  batchAddScheduleObject(data){
    return  axios.post(`${process.env.BASE_URL}/scheduleObject/batchAddScheduleObject`, data);
  },
  getScheduleRule(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleObject/getScheduleRule`, {params:data});
  },
  getSchedule(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleObject/getSchedule`, {params:data});
  },
  getScheduleRuleList(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleObject/getScheduleRuleList`, {params:data});
  },
  getTeacherTree(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleObject/getTeacherTree`, {params:data});
  },
  getClassroomTree(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleObject/getClassroomTree`, {params:data});
  },
  deleteScheduleRule(data){
    return  axios.delete(`${process.env.BASE_URL}/scheduleObject/deleteScheduleRule`, {data:data});
  },
  updateScheduleRule(data){
    return  axios.put(`${process.env.BASE_URL}/scheduleObject/updateScheduleObject`, data);
  },
}
export default scheduleObject



// WEBPACK FOOTER //
// ./src/api/scheduleObject.js